module.exports = __webpack_public_path__ + "assets/crosshair.0650de19.svg";